import { create } from 'zustand';

export type ToastVariant = 'success' | 'error' | 'info';

export interface Toast {
  id: number;
  text: string;
  variant: ToastVariant;
}

interface ToastState {
  toasts: Toast[];
  push: (text: string, variant?: ToastVariant, ttl?: number) => void;
  dismiss: (id: number) => void;
}

let nextId = 1;

export const useToast = create<ToastState>((set, get) => ({
  toasts: [],
  push: (text, variant = 'info', ttl = 2400) => {
    const id = nextId++;
    set((s) => ({ toasts: [...s.toasts, { id, text, variant }] }));
    setTimeout(() => get().dismiss(id), ttl);
  },
  dismiss: (id) =>
    set((s) => ({ toasts: s.toasts.filter((t) => t.id !== id) })),
}));

export const toast = {
  success: (t: string) => useToast.getState().push(t, 'success'),
  error: (t: string) => useToast.getState().push(t, 'error', 4000),
  info: (t: string) => useToast.getState().push(t, 'info'),
};
